import * as React from 'react';
import { PortfolioPane, PFHead, PFBalances } from '../../components/Portfolio/PortfolioBoxUI';
import PFTotal from './PFTotal';
import PFBalance from './PFBalance';
import coinPrices, { CoinProps } from '../../data/coinPrices';
import { PFProps } from '../../data/portfolioData';

type Props = {
  portfolio: PFProps;
};

const PortfolioBox: React.SFC<Props> = ({ portfolio: { title, balances } }) => (
  <PortfolioPane>
    <PFHead>{title}</PFHead>
    <PFTotal balances={balances} />
    <PFBalances>
      {balances.map(balance => {
        const coin: CoinProps = coinPrices[balance.coinId];
        return <PFBalance key={Math.random()} coin={coin} balance={balance} />;
      })}
    </PFBalances>
  </PortfolioPane>
);

export default PortfolioBox;



// WEBPACK FOOTER //
// ./src/containers/Portfolio/PortfolioBox.tsx